/* eslint-disable no-param-reassign */
/* eslint-disable no-eval */
import { useMemo } from 'react';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { formatNumber, formatPercentage } from 'utils/number';
import tradingDataStore from 'lib/stores/tradingData';
import useGetPortfolioData from 'hooks/useGetPortfolioData';
import { getColorBasedOnNumber } from 'utils/general';
import {
  getBuyAmountInvested,
  getProfitLoss,
  getSellAmountInvestedFee,
  getSellGain,
} from 'global/Securities/utils/formula';
import { CorporateActionStockType } from 'constants/trading';
import orderbookModalStore from './store';
import { PreviewItem } from './styled';

function AmendSellPreview() {
  const {
    company,
    configFormula: {
      data: { formula },
    },
  } = tradingDataStore();
  const { price, symbol, orders } = orderbookModalStore();
  const portfolioSymbol = useGetPortfolioData(symbol, false, true);
  const productType = company?.data?.type_company || '';
  const isCorporateAction = useMemo(
    () => CorporateActionStockType.includes(productType.toLowerCase()),
    [productType],
  );

  const dataPreview = orders.reduce(
    (acc, cur) => {
      const LOT = cur.order_total;
      const PRICE = price;
      const FEE_SELL = formula.fee_sell;
      const SELL_FEE = eval(formula.sell_amount_fee); // nosemgrep
      const SELL_AMOUNT = eval(formula.sell_amount_invested); // nosemgrep
      const SELL_AMOUNT_FEE = eval(formula.sell_amount_invested_fee); // nosemgrep

      const sellAmountInvestedFee = getSellAmountInvestedFee(
        LOT,
        price,
        isCorporateAction,
      );
      const buyAmountInvested = getBuyAmountInvested(
        LOT,
        portfolioSymbol ? portfolioSymbol.price_average_fee : 0,
      );
      const sellProfitLoss = getProfitLoss(
        sellAmountInvestedFee,
        buyAmountInvested,
      );
      const sellGain = getSellGain(sellProfitLoss, buyAmountInvested);

      acc.stock = cur.symbol;
      acc.price = PRICE;
      acc.lot += LOT;
      acc.fee += SELL_FEE;
      acc.proceed_amount += SELL_AMOUNT;
      acc.total_proceeds += SELL_AMOUNT_FEE;
      acc.sellPL += sellProfitLoss;
      acc.sellGain += sellGain;

      return acc;
    },
    {
      stock: '',
      price: 0,
      lot: 0,
      fee: 0,
      proceed_amount: 0,
      total_proceeds: 0,
      sellPL: 0,
      sellGain: 0,
    },
  );

  const previewData = [
    {
      label: <Text>Stock</Text>,
      value: <Text family="bold">{dataPreview.stock}</Text>,
    },
    {
      label: <Text>Lot</Text>,
      value: <Text>{formatNumber(dataPreview.lot, false)}</Text>,
    },
    {
      label: <Text>Price</Text>,
      value: <Text>{formatNumber(dataPreview.price, false)}</Text>,
    },
    {
      label: <Text>Proceed Amount</Text>,
      value: <Text>Rp {formatNumber(dataPreview.proceed_amount, false)}</Text>,
    },
    {
      label: <Text>Fee</Text>,
      value: <Text>Rp {formatNumber(dataPreview.fee, false)}</Text>,
    },
    {
      label: (
        <Text family="bold" as="span">
          Total Proceeds
        </Text>
      ),
      value: (
        <Text family="bold" as="span">
          Rp {formatNumber(dataPreview.total_proceeds, false)}
        </Text>
      ),
    },
    {
      label: <Text>Profit/Loss</Text>,
      value: (
        <Text color={getColorBasedOnNumber(dataPreview.sellPL)}>
          {formatNumber(dataPreview.sellPL, false)} (
          {dataPreview.sellPL > 0 && '+'}
          {formatPercentage(dataPreview.sellGain, false)})
        </Text>
      ),
    },
  ];

  return (
    <Flex direction="column" width="100%">
      {previewData.map((p) => (
        <PreviewItem key={`amend-sell-${p.label}`}>
          {p.label}
          {p.value}
        </PreviewItem>
      ))}
    </Flex>
  );
}

export default AmendSellPreview;
